export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const SET_USER_OPTION = 'SET_USER_OPTION';
